/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChildGroupCreateOrUpdate } from '../model/childGroupCreateOrUpdate';
import { ChildGroupDetail } from '../model/childGroupDetail';
import { ChildGroupSuggestion } from '../model/childGroupSuggestion';
import { ChildGroupWorkplaceTransfer } from '../model/childGroupWorkplaceTransfer';
import { ChildGroupWorkplaceTransferResponse } from '../model/childGroupWorkplaceTransferResponse';
import { PaginatedChildGroupListList } from '../model/paginatedChildGroupListList';
import { PatchedChildGroupCreateOrUpdate } from '../model/patchedChildGroupCreateOrUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClassesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Child group management.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesCreate(body: ChildGroupCreateOrUpdate, observe?: 'body', reportProgress?: boolean): Observable<ChildGroupDetail>;
    public classesCreate(body: ChildGroupCreateOrUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildGroupDetail>>;
    public classesCreate(body: ChildGroupCreateOrUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildGroupDetail>>;
    public classesCreate(body: ChildGroupCreateOrUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling classesCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChildGroupDetail>('post',`${this.basePath}/classes/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param uuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesDestroy(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public classesDestroy(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public classesDestroy(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public classesDestroy(uuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling classesDestroy.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/classes/${encodeURIComponent(String(uuid))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param isRemoved 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param search A search term.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesList(isRemoved?: boolean, limit?: number, offset?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedChildGroupListList>;
    public classesList(isRemoved?: boolean, limit?: number, offset?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedChildGroupListList>>;
    public classesList(isRemoved?: boolean, limit?: number, offset?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedChildGroupListList>>;
    public classesList(isRemoved?: boolean, limit?: number, offset?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isRemoved !== undefined && isRemoved !== null) {
            queryParameters = queryParameters.set('is_removed', <any>isRemoved);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedChildGroupListList>('get',`${this.basePath}/classes/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param uuid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesPartialUpdate(uuid: string, body?: PatchedChildGroupCreateOrUpdate, observe?: 'body', reportProgress?: boolean): Observable<ChildGroupDetail>;
    public classesPartialUpdate(uuid: string, body?: PatchedChildGroupCreateOrUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildGroupDetail>>;
    public classesPartialUpdate(uuid: string, body?: PatchedChildGroupCreateOrUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildGroupDetail>>;
    public classesPartialUpdate(uuid: string, body?: PatchedChildGroupCreateOrUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling classesPartialUpdate.');
        }


        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChildGroupDetail>('patch',`${this.basePath}/classes/${encodeURIComponent(String(uuid))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param uuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesRetrieve(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<ChildGroupDetail>;
    public classesRetrieve(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildGroupDetail>>;
    public classesRetrieve(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildGroupDetail>>;
    public classesRetrieve(uuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling classesRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ChildGroupDetail>('get',`${this.basePath}/classes/${encodeURIComponent(String(uuid))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * List of child groups.
     * @param isRemoved 
     * @param search A search term.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesSuggestionsList(isRemoved?: boolean, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ChildGroupSuggestion>>;
    public classesSuggestionsList(isRemoved?: boolean, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ChildGroupSuggestion>>>;
    public classesSuggestionsList(isRemoved?: boolean, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ChildGroupSuggestion>>>;
    public classesSuggestionsList(isRemoved?: boolean, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isRemoved !== undefined && isRemoved !== null) {
            queryParameters = queryParameters.set('is_removed', <any>isRemoved);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ChildGroupSuggestion>>('get',`${this.basePath}/classes/suggestions/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param body 
     * @param uuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesTransferToWorkplaceCreate(body: ChildGroupWorkplaceTransfer, uuid: string, observe?: 'body', reportProgress?: boolean): Observable<ChildGroupWorkplaceTransferResponse>;
    public classesTransferToWorkplaceCreate(body: ChildGroupWorkplaceTransfer, uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildGroupWorkplaceTransferResponse>>;
    public classesTransferToWorkplaceCreate(body: ChildGroupWorkplaceTransfer, uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildGroupWorkplaceTransferResponse>>;
    public classesTransferToWorkplaceCreate(body: ChildGroupWorkplaceTransfer, uuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling classesTransferToWorkplaceCreate.');
        }

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling classesTransferToWorkplaceCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChildGroupWorkplaceTransferResponse>('post',`${this.basePath}/classes/${encodeURIComponent(String(uuid))}/transfer-to-workplace/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Child group management.
     * @param body 
     * @param uuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classesUpdate(body: ChildGroupCreateOrUpdate, uuid: string, observe?: 'body', reportProgress?: boolean): Observable<ChildGroupDetail>;
    public classesUpdate(body: ChildGroupCreateOrUpdate, uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildGroupDetail>>;
    public classesUpdate(body: ChildGroupCreateOrUpdate, uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildGroupDetail>>;
    public classesUpdate(body: ChildGroupCreateOrUpdate, uuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling classesUpdate.');
        }

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling classesUpdate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChildGroupDetail>('put',`${this.basePath}/classes/${encodeURIComponent(String(uuid))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
